import groupBy from 'lodash.groupby';
import { TransactionStatusReport } from '../types';

const calculateTotal = (list: TransactionStatusReport[]) => {
  const nextStats = ([] as TransactionStatusReport[]).concat(list);

  const totalsArray: any[] = [];
  const totalByCurrency: any[] = [];

  nextStats.forEach((item) => {
    if (item.totals && item.totals.length) {
      totalsArray.push(item.totals);
    }
  });

  const flatted = totalsArray.flat();

  const groupedTotal = groupBy(flatted, (match) => match.currencyId);

  Object.keys(groupedTotal)?.forEach((item) => {
    let total = 0;

    groupedTotal[item].forEach((currency) => {
      total += currency.sum;
    });

    totalByCurrency.push({
      currencyId: item,
      sum: total,
    });
  });

  nextStats.push({
    id: 'total',
    baseellaStatus: 'TOTAL',
    totals: totalByCurrency,
  });

  return nextStats;
};

export default calculateTotal;
